<template>
  <div class="university-info-map">
    <div class="uni-card">
      <div class="uni-card__img">
        <img src="/storage/universities/ug-thumbnail.jpg" alt="" />
      </div>
      <div class="uni-card__info">
        <h1 class="title">
          {{ uni.title }}
        </h1>
        <div class="uni-type">
          <span v-if="uni.type == 'public'" class="badge p-2 badge-light">
            საჯარო
          </span>
          <span v-if="uni.type == 'private'" class="badge p-2 badge-info">
            კერძო
          </span>
        </div>
        <div class="card-text">
          <div v-if="uni.full_address">
            <small class="text-muted">{{ uni.full_address }} </small>
            <br />
          </div>

          <div v-if="uni.students_range">
            <small class="text-muted"
              >სტუდენეტების რაოდენობა: <b>300-400</b>
            </small>
            <br />
          </div>

          <div v-if="uni.price_range">
            <small class="text-muted">ფასი: <b>300-400</b> ლ</small>
            <br />
          </div>

          <div v-if="uni.website">
            <small class="text-muted">
              ვებსაიტი:
              <a target="_blank" :href="uni.website">{{ uni.website }}</a>
            </small>
            <br />
          </div>
        </div>
        <!-- <p class="text">{{ uni.description.substring(0, 60) }}...</p> -->

        <a
          :href="`/universities${uni.slug}`"
          type="button"
          class="btn btn-link btn-srulad"
          >სრულად</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["uni"],
};
</script>
